<template>
    <div>
      <iframe
        allow="camera; microphone; fullscreen; speaker; display-capture"
        width="100%"
        height="700px"
        :src="meta.meeting_url"
        frameborder="0"
        allowfullscreen
      ></iframe>
    </div>
</template>
<script>
import i18n from "@/i18n";
export default {
    name: "Dailyco",
    props: {
        meta: {
            type: Object,
            default: null
        }
    },
    mounted() {
      this.showNotification()
    },
    methods: {
      /** Show notification: Event is about to start */
      showNotification() {
        this.$store.dispatch("app/showSupportNotification", {
          screener_id: this.meta.screener_id,
          message: this.meta.title + i18n.t("screener.meeting.is_about_to_stream")
        });
      }
    }
}
</script>
